import React from 'react';
import formatMoney from '../../../../../utils/formatMoney';

const SecondStep = props => (




        <div className='fdvEquip-slides-item simpleSlide active'>

        {/*{props.listaPedidosXCortesia!==undefined?props.listaPedidosXCortesia.concat(props.pedidosNuevos.length>0?['']:[])
          .map(entry =>
              <div className='card card-lg card-plain'>
                <h3 className='card-title'>N° Pedidos</h3>

                {entry!==''?(
                  <p className='h5'>
                     {
                        props.listaPedidosXCortesiaPedido.filter(element => element.codFiveBono===entry).map(entry => {return entry.numPedidoVeh})
                        .map(element => (
                          <pedido>
                            {element + ' '}
                          </pedido>
                        ))
                      }
                  </p>
                ):(
                  <p className='h5'>
                     {
                        props.pedidosNuevos
                        .map(element => (
                          <pedido>
                            {element + ' '}
                          </pedido>
                        ))
                      }
                  </p>
                )}

                <hr className='modalBleed' />

                {
                  props.flagBonos === 'AgregarBonos'?(
                    <div className='' id='bonoSec'>
                  <h4 className='h5 bold'>Bono total ${props.pedidosToEdit.length>0?formatMoney(props.montoBonoProforma):formatMoney(props.montoBonoProforma)*props.arrayAsignarBonos.length}</h4>
                  <p className='mb-3 bold'>Ingresa la 'cantidad de vales x monto' que desees hasta llegar a ${props.pedidosToEdit.length>0?formatMoney(props.montoBonoProforma):formatMoney(props.montoBonoProforma)*props.arrayAsignarBonos.length}</p>
                </div>

                  ):(
                  <div class="js-open" id="cortesSec">
                    <h4 class="h5 bold">Bono por cortesía</h4>
                      <p class="mb-3 bold">Ingresa el monto de la cortesía</p>

                      <div class="row">
                          <div class="col-sm-4 form-group">
                             <input class="form-control" placeholder="Monto en dólares"  onChange={(e) => props.onChangeMontoCortesia(e,entry)} /><span class="error">mensaje de error</span>
                          </div>
                      </div>
                      <p class="mb-3 bold">Ingresa la 'cantidad de vales x monto' que desees hasta llegar a ${props.getCliente(null,entry).montoBonoProforma} </p>
                </div>
                  )
                }



                <div className='tableWrapper'>
                  <table className='table table-hover'>
                    <thead className='table-head'>
                      <tr>
                        <th />
                        <th>Cant. Vales</th>
                        <th />
                        <th>Monto</th>
                        <th />
                        <th align='right'>Totales</th>
                      </tr>
                    </thead>
                    <tbody>
                      {

                       props.getCliente(props.profroma,entry).bonoMonto.map((bono,id)=>(
                         <tr>
                            <td>
                              <button className='btn-clean' onClick={(e)=> props.removeBono(e,bono.id,props.profroma,entry)} >
                                <i className='ion-minus-circled h6 c-cyan' />
                              </button>
                            </td>
                            <td>
                              <div className='select'>
                                <select className='form-control'  value = {bono.value} onChange={(e) => props.onChangeSelectBox(e,bono.id,props.profroma,entry)}>
                                  <option value='1'>1</option>
                                  <option value='2'>2</option>
                                  <option value='3'>3</option>
                                  <option value='4'>4</option>
                                </select>
                                <div className='select-control-icon'><i className='ion-arrow-down-b' /></div>
                              </div><span className='error'>mensaje de error</span>
                            </td>
                            <td className='h6'>x</td>
                            <td>
                              <input className='form-control'  value = {bono.monto}  placeholder='Monto en dólares' onChange={(e) => props.onChangeInputs(e,bono.id,props.profroma,entry)} /><span className='error'>mensaje de error</span>
                            </td>
                            <td className='h6'>=</td>
                            <td align='right'>${formatMoney(bono.value * bono.monto)}</td>
                         </tr>
                       ))
                      }


                      <tr className='table-noHover'>
                        <td colSpan='5'>
                          <button className='btn btn-iconLeft btn-link' onClick={() => props.addItemsBonos(props.profroma,entry)} ><i className='ion-plus' /><span>Añadir campo</span></button>
                        </td>
                        <td className='bold h6' align='right'> {props.getCliente(null,entry).totalMontoBonoProforma} </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
        ):(*/}
          <div className='card card-lg card-plain'>
            <h3 className='card-title'>N° Pedidos</h3>
            <p className='h5'>

            {
                  props.arrayAsignarBonos.map(element => (
                    <pedido>
                      {element + ' '}
                    </pedido>
                  ))
                }
            </p>
            <hr className='modalBleed' />

            {
              props.flagBonos === 'AgregarBonos'?(
                <div className='' id='bonoSec'>
              <h4 className='h5 bold'>Bono total {props.codMonedaBono === "DOL"? 'US$' : 'S/'}{(props.montoBonoProforma)*props.arrayAsignarBonos.length}</h4>
              <p className='mb-3 bold'>Ingresa la 'cantidad de vales x monto' que desees hasta llegar a {props.codMonedaBono === "DOL"? 'US$' : 'S/'}{(props.montoBonoProforma)*props.arrayAsignarBonos.length}</p>
            </div>

              ):(
              <div class="js-open" id="cortesSec">
                <h4 class="h5 bold">Bono por cortesía</h4>
                  <p class="mb-3 bold">Ingresa el monto de la cortesía</p>

                  <div class="row">
                      <div class="col-sm-4 form-group">
                         <input class="form-control" placeholder="Monto en dólares" onChange={(e) => props.onChangeMontoCortesia(e)} /><span class="error">mensaje de error</span>
                      </div>
                  </div>
                  <p class="mb-3 bold">Ingresa la 'cantidad de vales x monto' que desees hasta llegar a {formatMoney(props.montoBonoProforma)}</p>
            </div>
              )
            }



            <div className='tableWrapper'>
              <table className='table table-hover'>
                <thead className='table-head'>
                  <tr>
                    <th />
                    <th>Cant. Vales</th>
                    <th />
                    <th>Monto</th>
                    <th />
                    <th align='right'>Totales</th>
                  </tr>
                </thead>
                <tbody>

                  {

                   props.getCliente(props.profroma).bonoMonto.map((bono,id)=>(
                     <tr>
                        <td>
                          <button className='btn-clean' onClick={(e)=> props.removeBono(e,bono.id,props.profroma)} >
                            <i className='ion-minus-circled h6 c-cyan' />
                          </button>
                        </td>
                        <td>
                          <input className='form-control' name='cantidad' value = {bono.value}  placeholder='Cantidad de vales' onChange={(e) => props.onChangeInputs(e,bono.id,props.profroma)} /><span className='error'>mensaje de error</span>
                        </td>
                        <td className='h6'>x</td>
                        <td>
                          <input className='form-control' name='monto' value = {bono.monto}  placeholder='Monto en dólares' onChange={(e) => props.onChangeInputs(e,bono.id,props.profroma)} /><span className='error'>mensaje de error</span>
                        </td>
                        <td className='h6'>=</td>
                        <td align='right'>{props.codMonedaBono === "DOL"? 'US$' : 'S/'}{formatMoney(bono.value * bono.monto)}</td>
                     </tr>
                   ))
                  }


                  <tr className='table-noHover'>
                    <td colSpan='5'>
                      <button className='btn btn-iconLeft btn-link' onClick={() => props.addItemsBonos(props.profroma)} ><i className='ion-plus' /><span>Añadir campo</span></button>
                    </td>
                    <td className='bold h6' align='right'> {props.codMonedaBono === "DOL"? 'US$' : 'S/'}{formatMoney(props.totalMontoBonoProforma)} </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
      {/*  )}*/}
        {props.listaPedidosXCortesia!==undefined?(

          <div className='modal-actions'>
            <button className='btn btn-default' onClick={props.previousStep}>Anterior</button>
            <button className='btn btn-primary pull-right' onClick={props.nextStep} disabled={props.listaBonosAll.map(entry => { if(entry.montoBonoProforma < entry.totalMontoBonoProforma || entry.montoBonoProforma > entry.totalMontoBonoProforma)  {return 0} else {return 1}} ).indexOf(0)>=0 } >Siguiente</button>
          </div>

        ):(
          <div className='modal-actions'>
            <button className='btn btn-default' onClick={props.previousStep}>Anterior</button>
            <button className='btn btn-primary pull-right' onClick={props.nextStep} disabled={+props.totalMontoBonoProforma === (props.flagBonos==='AgregarCortesia'?+props.montoBonoProforma:+props.montoBonoProforma*props.arrayAsignarBonos.length) ? false:true } >Siguiente</button>
          </div>

        )}


        </div>


  );

  export default SecondStep;



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/TabViews/Bonos/AgregarBonos/SecondStep.js